
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/pageSettingsPanel/settings/tabs/PageSettingsPermissionsTab/PermissionsTabComponents/permissionsThumbnails.scss.css.virtualfile';
        module.exports = {"root":"_root_142c0_1"};